import * as go from 'gojs';
import { ToolbarBorderStyle } from '@y42/canvas-components';

export const gojsDataToBorderStyleModel = (
  data: go.ObjectData,
  borderWidthProp: string,
  borderStyleProp: string,
): ToolbarBorderStyle => ({
  borderWidth: data[borderWidthProp],
  borderStyle: data[borderStyleProp],
});

export const borderStyleModelToGojsData = (
  { borderWidth, borderStyle }: ToolbarBorderStyle,
  borderWidthProp: string,
  borderStyleProp: string,
) => ({
  [borderWidthProp]: borderWidth,
  [borderStyleProp]: borderStyle,
});
